<template>
  <div>
    <van-dialog
      v-model="visible"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="dialog"
      :style="{
        background: `url(${backgroundImage}) no-repeat`
      }"
    >
      <div @click="removeClick" class="removeImage">
        <van-image :src="removeImage"> </van-image>
      </div>
      <div v-if="titleImage" class="title">
        <van-image :src="titleImage"> </van-image>
      </div>
      <div class="dialogWarp">
        <canvas ref="canvas" style="display: none"></canvas>
        <img
          style="width: 100%; display: none"
          ref="textListImage"
          class="textListImage"
          :src="textListImage"
        />
        <van-image
          @mousedown.native="longPressHandlerDown"
          @mouseup.native="longPressHandlerUp"
          @touchstart.native="longPressHandlerDown"
          @touchend.native="longPressHandlerUp"
          class="textListImage"
          :src="modifiedImage"
        />
        <van-image class="textImage" :src="textImage"> </van-image>
        <van-image class="textImage1" :src="textImage1"> </van-image>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'submitDialog',
  props: {
    visible: Boolean,
    titleImage: String,
    backgroundImage: String,
    removeImage: String,
    textImage: String,
    textImage1: String,
    textListImage: String,
    imgid: Number
  },
  data() {
    return {
      timeFn: null,
      modifiedImage: null
    }
  },
  mounted() {
    this.changeImage()
  },
  methods: {
    changeImage() {
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const image = this.$refs.textListImage
      const _this = this
      image.onload = () => {
        // 设置canvas大小
        canvas.width = 720
        canvas.height = 488
        // 绘制原始图片
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

        // 在这里修改图片，比如替换手机号
        // 假设手机号位于图片的(x, y)位置，使用`newPhoneNumber`替换`oldPhoneNumber`
        const newPhoneNumber = _this.imgid
        const x = 380 // 手机号码的x坐标
        const y = 391 // 手机号码的y坐标

        // 绘制新手机号码
        ctx.fillStyle = '#ffffff' // 背景色，根据实际情况设置
        ctx.font = '20px Arial' // 字体大小和类型，根据实际情况设置
        ctx.strokeStyle = '#240940'
        ctx.lineWidth = 3
        // ctx.strokeText(newPhoneNumber, 100, 100)
        ctx.strokeText(newPhoneNumber, x, y)
        ctx.fillText(newPhoneNumber, x, y)

        // 将修改后的canvas转换为DataURL
        _this.modifiedImage = canvas.toDataURL('image/png')
      }
    },
    removeClick(val) {
      this.$emit('changeVisible', val)
    },
    longPressHandlerDown() {
      let _this = this
      this.timeFn = setTimeout(() => {
        let a = document.createElement('a')
        let event = new MouseEvent('click')
        a.download = 'photo' // 设置图片名称
        a.href = _this.modifiedImage // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }, 1000)
    },
    longPressHandlerUp() {
      clearTimeout(this.timeFn)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  background-size: 100% 100% !important;
  width: 350px;
  .title {
    padding: 2rem;
    padding-bottom: 0rem;
    /deep/ .van-image {
      width: 30%;
      display: block;
      margin: 0 auto;
    }
  }
}
.removeImage {
  position: absolute;
  width: 20px;
  top: 15px;
  right: 15px;
  z-index: 1000;
}
.dialogWarp {
  height: 300px;
  padding: 1rem 40px;
  position: relative;
  /deep/ .van-image:nth-child(3) {
    width: 100%;
    margin: 0 auto;
    display: block;
  }
  /deep/ .van-image:nth-child(4) {
    width: 100%;
    margin: 1rem auto;
    display: block;
  }
  /deep/ .van-image:nth-child(5) {
    width: 80%;
    margin: 0 auto;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/submitDialog/index.vue